import { cn } from '@commenda/utils';

import { ChartColorHelper } from './chartColors';
import type { IChartTooltipProps } from './chartTypes';

export const ChartTooltip = ({
  active,
  label,
  payload,
  valueFormatter,
  preliminary = false,
}: IChartTooltipProps) => {
  if (!active || payload.length === 0) return null;
  return (
    <div className="rounded-md border border-border-secondary bg-bg-primary text-xs shadow-md">
      <div className="border-b border-border-secondary px-lg py-sm">
        <p className="font-medium text-text-primary">{label}</p>
        {preliminary && (
          <p className="text-text-tertiary">Preliminary · books not closed</p>
        )}
      </div>
      <div className="space-y-xs px-lg py-sm">
        {payload.map(({ category, value, color, formattedValue }) => (
          <div
            key={category}
            className="flex items-center justify-between gap-4xl"
          >
            <div className="flex items-center gap-sm">
              <span
                aria-hidden="true"
                className={cn(
                  'h-[3px] w-3.5 shrink-0 rounded-full',
                  ChartColorHelper.className(color, 'bg')
                )}
              />
              <p className="whitespace-nowrap text-text-secondary">
                {category}
              </p>
            </div>
            <p className="whitespace-nowrap text-right font-medium tabular-nums text-text-primary">
              {formattedValue ?? valueFormatter(value)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
